module.exports = __webpack_public_path__ + "static/media/search.7f2659d4.svg";